import { PublicationComponent } from './app/item-page/simple/item-types/publication/publication.component';

export const ENTRY_COMPONENTS = [
  PublicationComponent
];
